import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Box, Button, styled } from '@mui/material';

import { homeBackgroundImage } from '@frontend/assets';
import { routes } from '@frontend/router/routes';

import { HotelSearchBar } from './Search/HotelSearchBar';
import { useHotelSearch } from './Search/HotelSearchContext';
import { appendHotelAvailabilityQueryParamsToUrl } from './Search/helpers';

const SearchLayout = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  background,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  height: 'calc(100vh - 64px)',
}));

const SearchBarContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '1156px',
  display: 'flex',
  backgroundColor: theme.palette.common.white,
  gap: theme.spacing(2),
  padding: theme.spacing(3),
  position: 'relative',
  boxShadow: theme.shadows[10],
  borderRadius: theme.spacing(2),
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

const background = `url("${homeBackgroundImage}")`;

export const HotelAvailabilitySearchLayout = () => (
  <SearchLayout>
    <SearchBarContainer>
      <HotelSearchBar />
    </SearchBarContainer>
  </SearchLayout>
);
